// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';

interface IProps {
    disabled: boolean;
    disabledColor: string;
    checked: boolean;
    checkMarkColor?: string;
    checkBoxColor: string;
}

class SvgCheckbox extends React.Component<IProps, {}> {
    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const {
            checked,
            disabled,
            disabledColor = '',
            checkMarkColor = '',
            checkBoxColor
        } = this.props;

        let boxStrokeColor = 'none';
        let markStrokeColor = 'none';
        if (checked) {
            markStrokeColor = disabled ? disabledColor : checkMarkColor;
        } else {
            boxStrokeColor = disabled ? disabledColor : checkBoxColor;
        }

        return (
            <svg height="100%" width="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
                <rect
                    x="10%"
                    y="10%"
                    height="80%"
                    width="80%"
                    stroke={boxStrokeColor}
                    fill="none"
                    strokeWidth="6%"
                />
                <polyline
                    strokeLinecap="round"
                    points="0,57 35,93 93,0"
                    fill="none"
                    stroke={markStrokeColor}
                    strokeWidth="20%"
                />
            </svg>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default SvgCheckbox;
